// extracted by mini-css-extract-plugin
export default {"buttons":"styles_buttons__CEPmL","button-wrapper":"styles_button-wrapper__VZRWL","complete-button":"styles_complete-button__kR4Re"};